/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getMedicines } from 'app/entities/medicine/medicine.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { getEntities as getTreatmentCycles } from 'app/entities/treatment-cycle/treatment-cycle.reducer';
import { getEntities as getRegimenDrugs } from 'app/entities/regimen-drug/regimen-drug.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-drug.reducer';

export const TreatmentDrugUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const medicines = useAppSelector(state => state.medicine.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const treatmentCycles = useAppSelector(state => state.treatmentCycle.entities);
  const regimenDrugs = useAppSelector(state => state.regimenDrug.entities);
  const treatmentDrugEntity = useAppSelector(state => state.treatmentDrug.entity);
  const loading = useAppSelector(state => state.treatmentDrug.loading);
  const updating = useAppSelector(state => state.treatmentDrug.updating);
  const updateSuccess = useAppSelector(state => state.treatmentDrug.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-drug${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMedicines({}));
    dispatch(getNurses({}));
    dispatch(getTreatmentCycles({}));
    dispatch(getRegimenDrugs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentDrugEntity,
      ...values,
      administeredDrug: medicines.find(it => it.id.toString() === values.administeredDrug?.toString()),
      administeringNurse: nurses.find(it => it.id.toString() === values.administeringNurse?.toString()),
      validatingNurse: nurses.find(it => it.id.toString() === values.validatingNurse?.toString()),
      cycle: treatmentCycles.find(it => it.id.toString() === values.cycle?.toString()),
      regimenDrug: regimenDrugs.find(it => it.id.toString() === values.regimenDrug?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentDrugEntity,
          administeredDrug: treatmentDrugEntity?.administeredDrug?.id,
          administeringNurse: treatmentDrugEntity?.administeringNurse?.id,
          validatingNurse: treatmentDrugEntity?.validatingNurse?.id,
          cycle: treatmentDrugEntity?.cycle?.id,
          regimenDrug: treatmentDrugEntity?.regimenDrug?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.treatmentDrug.home.createOrEditLabel" data-cy="TreatmentDrugCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.treatmentDrug.home.createOrEditLabel">Create or edit a TreatmentDrug</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-drug-id"
                  label={translate('tinyMedicRestApp.treatmentDrug.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDrug.administered')}
                id="treatment-drug-administered"
                name="administered"
                data-cy="administered"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDrug.administedDose')}
                id="treatment-drug-administedDose"
                name="administedDose"
                data-cy="administedDose"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDrug.administedDoseUnit')}
                id="treatment-drug-administedDoseUnit"
                name="administedDoseUnit"
                data-cy="administedDoseUnit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDrug.administedDoseDilution')}
                id="treatment-drug-administedDoseDilution"
                name="administedDoseDilution"
                data-cy="administedDoseDilution"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDrug.active')}
                id="treatment-drug-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDrug.cursor')}
                id="treatment-drug-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDrug.lastUpdated')}
                id="treatment-drug-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDrug.microSec')}
                id="treatment-drug-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDrug.timestampEntry')}
                id="treatment-drug-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentDrug.notes')}
                id="treatment-drug-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                id="treatment-drug-administeredDrug"
                name="administeredDrug"
                data-cy="administeredDrug"
                label={translate('tinyMedicRestApp.treatmentDrug.administeredDrug')}
                type="select"
              >
                <option value="" key="0" />
                {medicines
                  ? medicines.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-drug-administeringNurse"
                name="administeringNurse"
                data-cy="administeringNurse"
                label={translate('tinyMedicRestApp.treatmentDrug.administeringNurse')}
                type="select"
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-drug-validatingNurse"
                name="validatingNurse"
                data-cy="validatingNurse"
                label={translate('tinyMedicRestApp.treatmentDrug.validatingNurse')}
                type="select"
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-drug-cycle"
                name="cycle"
                data-cy="cycle"
                label={translate('tinyMedicRestApp.treatmentDrug.cycle')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentCycles
                  ? treatmentCycles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-drug-regimenDrug"
                name="regimenDrug"
                data-cy="regimenDrug"
                label={translate('tinyMedicRestApp.treatmentDrug.regimenDrug')}
                type="select"
              >
                <option value="" key="0" />
                {regimenDrugs
                  ? regimenDrugs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/treatment-drug" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentDrugUpdate;
